import React from "react";

export const featureScreenshotSources = {
  "brand-ready-short-links": "/marketing/link-shortener-dashboard.png",
  "password-protection": "/marketing/link-shortener-dashboard.png",
  "mobile-targeting": "/marketing/bio-pages-mobile-mockup.png",
  "custom-social-previews": "/marketing/social-preview.png",
  "detailed-click-analytics": "/marketing/analytics-dashboard.png",
  "live-performance-analytics": "/marketing/analytics-dashboard.png",
  "a-b-testing": "/marketing/link-shortener-dashboard.png",
  "geo-targeting": "/marketing/analytics-dashboard.png",
  "retargeting-pixels": "/marketing/link-shortener-dashboard.png",
  "conversion-tracking": "/marketing/analytics-dashboard.png",
  "link-expiration-fallback": "/marketing/link-shortener-dashboard.png",
  "expiration-and-controls": "/marketing/link-shortener-dashboard.png",
  "bio-pages": "/marketing/bio-pages-mobile-mockup.png",
  "custom-domains": "/marketing/campaigns-banner.png",
  "bulk-operations": "/marketing/link-shortener-dashboard.png",
  campaigns: "/marketing/campaigns-banner.png",
};

export function BioPagesFeatureMark({ title = "Bio Pages", width = 64, height = 64, ...props }) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      {...props}
    >
      <rect x="10" y="8" width="44" height="48" rx="14" fill="#f7f7f5" stroke="#d7d5cf" />
      <circle cx="32" cy="22" r="8" fill="#2383e2" />
      <rect x="20" y="33" width="24" height="5" rx="2.5" fill="#37352f" />
      <rect x="18" y="41" width="28" height="5" rx="2.5" fill="#d0d0cc" />
      <rect x="18" y="49" width="20" height="4" rx="2" fill="#e5e4df" />
    </svg>
  );
}

export function CampaignsFeatureMark({ title = "Campaigns", width = 64, height = 64, ...props }) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      {...props}
    >
      <rect x="9" y="11" width="46" height="42" rx="12" fill="#f7f7f5" stroke="#d7d5cf" />
      <rect x="17" y="20" width="30" height="6" rx="3" fill="#2383e2" />
      <rect x="17" y="31" width="20" height="5" rx="2.5" fill="#0f7b6c" />
      <rect x="17" y="40" width="24" height="5" rx="2.5" fill="#e5e4df" />
      <circle cx="48" cy="22" r="4" fill="#cb912f" />
      <circle cx="48" cy="40" r="4" fill="#d44040" />
    </svg>
  );
}
